import { gql } from "@apollo/client";

export const GET_ADICIONALES_CONTRATO = gql`
query EvaluacionesAdicionales (
    $idEvaluacion: Int!
) {
    evaluacionAdicionalByIdEvaluacion (
        idEvaluacion: $idEvaluacion
    ){
       idComboRIValorReqAdicional
       idComboRIValorReqAdicionalNavigation{
            valor
       }
    }
}`;

export const adaptAdicionalesContrato = (adicional) => {
  return {
    requerimientosAdicionales: adicional?.evaluacionAdicionalByIdEvaluacion?.map((x) => x.idComboRIValorReqAdicionalNavigation.valor)
  };
};

export const adaptAdicionalesIdsContrato = (adicional) => {
  return {
    requerimientosAdicionales: adicional?.evaluacionAdicionalByIdEvaluacion?.map((x) => x.idComboRIValorReqAdicional)
  };
};